<template>
    <div class="container router-view scoreShop">
        <div class="header">
            <div class="item">
                <div class="title">积分</div>
                <div class="content">
                    <span :class="{ active: activeNav === 1 }" @click="changeNav(null, null, 1)">不限</span>
                    <span :class="{ active: activeNav === 2 }" @click="changeNav(1, 100, 2)">1-100</span>
                    <span
                        :class="{ active: activeNav === 3 }"
                        @click="changeNav(101, 200, 3)"
                    >101-200</span>
                    <span
                        :class="{ active: activeNav === 4 }"
                        @click="changeNav(201, 300, 4)"
                    >201-300</span>
                    <span
                        :class="{ active: activeNav === 5 }"
                        @click="changeNav(301, 400, 5)"
                    >301-400</span>
                    <span
                        :class="{ active: activeNav === 6 }"
                        @click="changeNav(400, null, 6)"
                    >400以上</span>
                </div>
            </div>
        </div>

        <div class="productItem" v-if="goodsList">
            <div class="item" v-for="(item, index) in goodsList.list" :key="index">
                <div class="img">
                    <img :src="item.imgUrl" />
                </div>
                <div class="content">
                    <div class="name">
                        <div>{{ item.name }}</div>
                        <div>
                            <span>积分：</span>
                            <span class="score">{{ item.consumeValue }}</span>
                        </div>
                    </div>
                    <div class="exchange" @click="onExchange(item.id)">兑换</div>
                </div>
            </div>
            <div
                class="table-empty"
                v-if="!goodsList || !goodsList.list || (goodsList.list && goodsList.list.length === 0)"
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>

        <div class="pagination">
            <el-pagination
                v-if="goodsList && goodsList.list.length > 0"
                background
                layout="prev, pager, next,total"
                :total="goodsList.count"
                :page-size="goodsList.pageSize"
                :current-page="goodsList.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="积分兑换" :visible.sync="exchangeDialog">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="收货人" prop="receiveUser">
                    <el-input v-model="form.receiveUser"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="receivePhone">
                    <el-input v-model="form.receivePhone"></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="pca">
                    <el-cascader
                        style="width: 100%"
                        :options="areaAddress"
                        :props="props"
                        v-model="form.pca"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="receiveAddress">
                    <el-input v-model="form.receiveAddress"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="onSubmit()">保存</el-button>
                    <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../fetch/common';
import { address } from '../fetch/address';

export default {
    name: 'scoreShop',
    data() {
        return {
            goodsList: null,
            params: {
                pageSize: 12,
                page: 1,
                endConsumeValue: null,
                startConsumeValue: null,
            },
            activeNav: 1,
            form: {
                receiveUser: '',
                receiveAddress: '',
                receivePhone: '',
                pca: '',
                goodsId: null,
            },
            rules: {
                receiveUser: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
                receiveAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
                pca: [{ required: true, message: '请选择省市区', trigger: 'blur' }],
                receivePhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
            },
            exchangeDialog: false,
            props: {
                value: 'label',
                children: 'children',
            },
        };
    },
    computed: {
        areaAddress() {
            return address;
        },
    },
    methods: {
        handleCurrentChange(page) {
            this.params.page = page;
            this.getList();
        },
        getList() {
            apis.getIntegralGoods(this.params).then(res => {
                this.goodsList = res;
            });
        },
        changeNav(start, end, index) {
            this.params.startConsumeValue = start;
            this.params.endConsumeValue = end;
            this.activeNav = index;
            this.getList();
        },
        onExchange(id) {
            this.exchangeDialog = true;
            this.form.goodsId = id;
        },
        onSubmit() {
            if (!this.form.goodsId) {
                return;
            }
            this.$refs['form'].validate(valid => {
                if (valid) {
                    const { pca, ...rest } = this.form;
                    const params = {
                        ...rest,
                        receiveProvince: pca[0],
                        receiveCity: pca[1],
                        receiveArea: pca[2],
                    };
                    apis.exchangeGoods(params).then(res => {
                        this.$message.success('兑换成功');
                        this.resetForm();
                        this.exchangeDialog = false;
                    });
                }
            });
        },
        resetForm() {
            this.$refs['form'].resetFields();
            this.form.pca = [];
            this.form.goodsId = null;
        },
    },
    mounted() {
        this.getList();
    },
};
</script>

<style lang="less" scoped>
.scoreShop {
    .header {
        background-color: #fff;
        padding: 20px 0;
        font-size: 14px;
        .item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: start;
            -ms-flex-pack: start;
            justify-content: flex-start;
            line-height: 30px;
            margin-top: 10px;
            text-align: center;
            .title {
                width: 100px;
                color: #9e9e9e;
            }
            .content {
                -webkit-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                span {
                    padding: 0 20px;
                    color: #2b2b2b;
                    cursor: pointer;
                }

                .active {
                    background-color: #3c9539;
                    border-radius: 20px;
                    color: #fff;
                }
            }
        }
    }

    .productItem {
        margin-top: 30px;
        position: relative;
        min-height: 300px;
        width: 1220px;
        overflow: hidden;
        .item {
            float: left;
            width: 285px;
            height: 250px;
            margin-right: 20px;
            margin-bottom: 20px;
            overflow: hidden;
            background-color: #ffffff;
            box-shadow: 0px 0px 10px 0px rgba(216, 216, 216, 0.5);
            border-radius: 10px;
            .img {
                height: 180px;
                border-bottom: 1px dashed #eeeeee;
                padding: 15px 68px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 10px;

                .name {
                    font-size: 14px;
                    & > div {
                        margin-bottom: 5px;
                    }
                    & > div:last-child {
                        font-size: 14px;
                        color: #8f8f8f;
                        .score {
                            font-size: 18px;
                            color: #ff9236;
                        }
                    }
                }

                .exchange {
                    float: right;
                    width: 71px;
                    height: 30px;
                    line-height: 30px;
                    background-image: linear-gradient(90deg, #ff9236 0%, #ff6936 100%);
                    border-radius: 33px;
                    color: #ffffff;
                    cursor: pointer;
                    text-align: center;
                }
            }
        }
    }
}
</style>